import { render } from "./WatchesOrdered.vue?vue&type=template&id=d4c181ba"
import script from "./WatchesOrdered.vue?vue&type=script&lang=js"
export * from "./WatchesOrdered.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__